import React from 'react';
import { useSelector } from 'react-redux';

import ApolloClientProvider from '@swf/core/providers/ApolloClientProvider';
import { select } from '@swf/core/store';

const WalletApolloProvider: React.FunctionComponent = ({ children }) => {
  const { idpToken } = useSelector(select.session.get);
  const { apiDomain } = useSelector(select.config.get);

  if (!apiDomain) return null;

  const wsUrl = new URL(apiDomain);
  wsUrl.protocol = 'wss';
  wsUrl.pathname = '/pam/wallet/subscription';

  const httpUrl = new URL(apiDomain);
  httpUrl.pathname = '/pam/wallet/graphql';

  return (
    <ApolloClientProvider wsLinkUrl={wsUrl.href} httpLinkUri={httpUrl.href} token={idpToken}>
      {children}
    </ApolloClientProvider>
  );
};

export default WalletApolloProvider;
